/** Supported petition signature page rendering modes. */
export const SIGNATURE_PAGES_MODES = ['FullPage', 'SignatureBlockOnly'] as const;

/** Petition signature page rendering mode. */
export type SignaturePagesMode = (typeof SIGNATURE_PAGES_MODES)[number];

/** Creator-level petition settings returned by the API. */
export type PetitionSettings = {
  creatorId: string;
  signaturePagesEnabled: boolean;
  signaturePagesMode: SignaturePagesMode;
};
